
export default {
  props: {
    floating: {
      type: Boolean,
      default: false,
    },
  },
}
